module.exports = __webpack_public_path__ + "static/img/hi.e3aad429.png";